<template>
  <div>
    <section class="">
      <div class="">
        <div class="new-banner d-flex justify-content-center">
          <div class="new-banner-img">
            <img class="desktop" src="../assets/img/main-banner.jpg">
          </div>
          <div class="new-banner-container d-flex align-items-center pl-4 pr-4 pb-5 pt-2">
            <div class="new-banner-content container-fluid p-0 d-flex flex-column">
              <div class="row">
                <div class="col-12 title1 p-0 pt-3">
                  {{$t('home.title')}}
                </div>
              </div>
              <div class="row flex-grow-1">
                <div class="align-self-start p-0">
                  <div class="title2 pt-1">
                    {{$t('home.title2')}}
                  </div>
                  <div class="list">
                    <ul>
                      <li>{{$t('home.pro1')}}</li>
                      <li>{{$t('home.pro2')}}</li>
                      <li>{{$t('home.pro3')}}</li>
                      <li>{{$t('home.pro4')}}</li>
                      <li>{{$t('home.pro5')}}</li>
                      <li>{{$t('home.pro6')}}</li>
                    </ul>
                  </div>
                  <div class="banner-bottom">
                    {{$t('home.pro_bottom')}}
                  </div>
                  <div class="arrow-button pb-2">
                    <button type="button" class="btn" @click="smoothscroll('why-you-should-know-your-genome')">
                      <img id="card-img-overlay_3" alt="Arrow Down Icon" src="../assets/img/down-arrow.png">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="new-banner-mobile d-flex d-block d-xl-none">
          <div class="new-banner-container-mobile d-flex align-items-center pl-4 pr-4 pb-0 pt-2">
            <div class="new-banner-content new-banner-content-mobile container-fluid p-0">
              <div class="row">
                <div class="col-12 title1 p-0 pt-3">
                  {{$t('home.title')}}
                </div>
              </div>
              <div class="row flex-grow-1" style="position: relative;">
                <div class="align-self-start p-0">
                  <div class="title2 pt-1">
                    {{$t('home.title2')}}
                  </div>
                  <div class="list">
                    <ul>
                      <li>{{$t('home.pro1')}}</li>
                      <li>{{$t('home.pro2')}}</li>
                      <li>{{$t('home.pro3')}}</li>
                      <li>{{$t('home.pro4')}}</li>
                      <li>{{$t('home.pro5')}}</li>
                      <li>{{$t('home.pro6')}}</li>
                    </ul>
                  </div>
                  <div class="banner-bottom">
                    {{$t('home.pro_bottom')}}
                  </div>
                  <div class="arrow-button-mobile pt-2 pb-2">
                    <button type="button" class="btn" @click="smoothscroll('why-you-should-know-your-genome')">
                      <img id="card-img-overlay_3" alt="Arrow Down Icon" src="../assets/img/down-arrow.png">
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <div class="container main-page-section numbers-section pt-5">
      <div class="row numbers-header text-center">
        <div class="col">
          <h2 class="title pb-3">{{$t('home.counters.header')}}</h2>
        </div>
      </div>
      <div class="row numbers-row justify-content-around pb-5">
        <div class="col-12 col-xl-auto text-center">
          <div class="row">
            <div class="col">
              {{$t('home.counters.counter_1.top')}}&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col numbers-big numbers-big-first">
              {{$t('home.counters.counter_1.number')}}
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{$t('home.counters.counter_1.bottom')}}
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-auto text-center mt-5 mt-xl-0">
          <div class="row">
            <div class="col">
              {{$t('home.counters.counter_2.top')}}
            </div>
          </div>
          <div class="row">
            <div class="col numbers-big numbers-big-second">
              {{$t('home.counters.counter_2.number')}}
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{$t('home.counters.counter_2.bottom')}}
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6 col-xl-auto text-center mt-5 mt-xl-0">
          <div class="row d-none d-md-block">
            <div class="col numbers-text">
              {{$t('home.counters.counter_3.top')}}&nbsp;
            </div>
          </div>
          <div class="row">
            <div class="col numbers-big numbers-big-third">
              {{$t('home.counters.counter_3.number')}}
            </div>
          </div>
          <div class="row">
            <div class="col">
              {{$t('home.counters.counter_3.bottom')}}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Why you should know your genome? -->
    <div class="why-you-should-know-your-genome pb-5">
      <div class="container">
        <div class="row text-center">
          <div class="col-12">
            <h2 id="why-you-should-know-your-genome" class="title">{{$t('home.why_you_should_know_your_genome')}}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-justify">
            <div class="" v-html="$t('home.why_you_should_know_your_genome_short_description')"></div>
          </div>
        </div>
        <div class="row pt-5">
          <div class="col-12 col-md-6 col-lg-4 pb-3 pb-3">
            <router-link :to="{ name: 'why-you-should-know-your-genome-view', hash: '#ryzyka' }">
                <button type="button" class="btn btn-home-tiles">
                  {{$t('home.tiles.1')}}
                </button>
            </router-link>
            </div>
            <div class="col-12 col-md-6 col-lg-4 pb-3 pb-3">
              <router-link :to="{ name: 'why-you-should-know-your-genome-view', hash: '#ryzyka' }">
                <button type="button" class="btn btn-home-tiles">
                  {{$t('home.tiles.2')}}
                </button>
              </router-link>
            </div>
            <div class="col-12 col-md-6 col-lg-4 pb-3 pb-3">
              <router-link :to="{ name: 'why-you-should-know-your-genome-view', hash: '#profilaktyka' }">
                <button type="button" class="btn btn-home-tiles">
                  {{$t('home.tiles.3')}}
                </button>
              </router-link>
            </div>
            <div class="col-12 col-md-6 col-lg-4 pb-3 pb-3">
              <router-link :to="{ name: 'why-you-should-know-your-genome-view', hash: '#odpowiedz-na-leki' }">
                <button type="button" class="btn btn-home-tiles">
                  {{$t('home.tiles.4')}}
                </button>
              </router-link>
            </div>
            <div class="col-12 col-md-6 col-lg-4 pb-3 pb-3">
              <router-link :to="{ name: 'why-you-should-know-your-genome-view', hash: '#terapia' }">
                <button type="button" class="btn btn-home-tiles">
                  {{$t('home.tiles.5')}}
                </button>
              </router-link>
            </div>
            <div class="col-12 col-md-6 col-lg-4 pb-3 pb-3">
              <router-link :to="{ name: 'why-you-should-know-your-genome-view', hash: '#jedno-badanie' }">
                <button type="button" class="btn btn-home-tiles">
                  {{$t('home.tiles.6')}}
                </button>
              </router-link>
            </div>
        </div>

        <div class="row text-center">
          <div class="col-md-12">
            <button type="button" class="btn btn-darkblue mt-5"
              @click="goto('why-you-should-know-your-genome-view')">{{$t('sets.read_more')}}</button>
          </div>
        </div>
      </div>
    </div>

    <!-- What is the difference? -->
    <div class="what-is-the-difference pb-5">
      <div class="container">
        <div class="row text-center">
          <div class="col-12">
            <h2 class="title">{{$t('home.what_is_the_difference')}}</h2>
          </div>
        </div>
        <div class="row">
          <div class="col-12 text-justify">
            <p class="card-text">
              <div class="carousel-floating compare-floating float-left p-0 pr-md-3 pb-2">
                <img src="../assets/img/chromosom17_Genotyping.png" class="img-fluid d-none" alt="...">
                <img src="../assets/img/chromosom17_Genotyping_v2.png" class="img-fluid d-none" alt="...">
                <VueCompareImage
                  leftImage="../dist/chromosom17_Genotyping.png"
                  rightImage="../dist/chromosom17_Genotyping_v2.png"
                  leftLabel="Tańsze testy predyspozycji do nowotworów"
                  rightLabel="Badanie całego genomu - Genomed" />
              </div>
              {{$t('home.what_is_the_difference_short_description')}}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- how it works -->
    <div class="how-it-works pt-5 pb-5" id="section1">
      <div class="container">
        <div class="row text-center">
          <div class="col-12">
            <h2 class="title">{{$t('home.how_it_works')}}</h2>
          </div>
        </div>
        <div class="row sin pt-5">
          <div class="col-lg col-md-12 col-sm-12 col1 col">
            <img src="../assets/img/hand-press-icon.png" alt="" class="img">
            <h5 class="description">{{$t('home.choose_your_option')}}</h5>
          </div>
          <div class="col-md col-con">
            <img src="../assets/img/sin-down.png" alt="" class="img">
          </div>
          <div id="sciezka1">
            <img src="../assets/img/sciezka1.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col2 col">
            <h5 class="description_mobilna">
              {{$t('home.use_kit_and_send_sample')}}
            </h5>
            <img src="../assets/img/car-icon.png" alt="" class="img">
            <h5 class="description">
              {{$t('home.use_kit_and_send_sample')}}
            </h5>
          </div>
          <div class="col-lg col-con">
            <img src="../assets/img/sin-up.png" alt="" class="img">
          </div>
          <div id="sciezka2">
            <img src="../assets/img/sciezka2.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col3 col">
            <img src="../assets/img/lab-icon.png" alt="" class="img">
            <h5 class="description">{{$t('home.our_lab_will_test_it')}}</h5>
          </div>
          <div class="col-lg col-con">
            <img src="../assets/img/sin-down.png" alt="" class="img">
          </div>
          <div id="sciezka3">
            <img src="../assets/img/sciezka3.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col4 col">
            <h5 class="description_mobilna">{{$t('home.download_results')}}</h5>
            <img src="../assets/img/hand-num-icon.png" alt="" class="img">
            <h5 class="description">{{$t('home.download_results')}}</h5>
          </div>
          <div class="col-md col-con">
            <img src="../assets/img/sin-up.png" alt="" class="img">
          </div>
          <div id="sciezka4">
            <img src="../assets/img/sciezka4.png" alt="">
          </div>
          <div class="col-lg col-md-12 col-sm-12 col5 col">
            <img src="../assets/img/display-icon.png" alt="" class="img">
            <h5 class="description">
              {{$t('home.register_video_consultation')}}
            </h5>
          </div>
        </div>
        <div class="row text-center">
          <div class="col-md-12 pt-0 pt-lg-5 pb-3">
            <button type="button" class="btn btn-darkblue" @click="goto('how-it-works-view')">{{$t('sets.read_more')}}</button>
          </div>
        </div>
      </div>
    </div>


    <!-- packages -->
    <div class="bg packages mt-5" id="packages_section">
      <div class="container">
        <div class="row text-center">
          <div class="col-12">
            <h2 class="title">{{$t('sets.our_sets')}}</h2>
          </div>
        </div>
        <div class="row packages-items mb-3 justify-content-center">
          <div id="packages_basic" class="col-12 col-md-6 col-xl-4 mt-4">
            <div class="card h-100 basic">
              <div class="card-body d-flex flex-column">
                <h5 class="card-title">{{$t('sets.basic')}}</h5>
                <p class="card-text">{{$t('sets.basic_info')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.basic_opt1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.basic_opt2')}}</p>
                  </li>
                </ul>
                <div class="container buttons-container mt-auto">
                  <div class="row justify-content-center">
                    <div class="col-auto">
                      <a class="btn " type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true"
                        aria-controls="collapseOne">
                        {{$t('sets.read_more')}}
                      </a>
                    </div>
                    <div class="col-auto">
                      <a class="btn ml-1" type="button" target="_blank"
                        :href="$t('sets.basic_link')">
                        {{$t('order')}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="packages_advanced" class="col-12 col-md-6 col-xl-4 mt-4">
            <div class="card h-100 advanced">
              <div class="card-body d-flex flex-column">
                <h5 class="card-title">{{$t('sets.advanced')}}</h5>
                <p class="card-text">{{$t('sets.advanced_info')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.basic_opt1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.basic_opt2')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt2')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt3')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt4')}}</p>
                  </li>
                </ul>
                <div class="container buttons-container mt-auto">
                  <div class="row mb-3 justify-content-center">
                    <div class="col-auto">
                      <a class="btn" type="button" target="_blank"
                        href="http://zapisy.genomed.pl/calendar/?name=genom-profilaktyczny-konsultacja-genetyczna">
                        {{$t('sets.book_a_consultation')}}
                      </a>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-auto">
                      <a class="btn" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false"
                        aria-controls="collapseTwo">
                        {{$t('sets.read_more')}}
                      </a>
                    </div>
                    <div class="col-auto">
                      <a class="btn ml-1" type="button" target="_blank"
                      :href="$t('sets.advanced_link')">
                        {{$t('order')}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div id="packages_premium" class="col-12 col-md-6 col-xl-4 mt-4">
            <div class="card h-100 premium">
              <div class="card-body d-flex flex-column">
                <h5 class="card-title">{{$t('sets.premium')}}</h5>
                <p class="card-text">{{$t('sets.premium_info')}}</p>
                <ul class="list-group ">
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.basic_opt1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.basic_opt2')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt2')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt3')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.advanced_opt4')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.premium_opt1')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.premium_opt2')}}</p>
                  </li>
                  <li class="item d-flex">
                    <div class="minus"></div>
                    <p class="card-text">{{$t('sets.premium_opt3')}}</p>
                  </li>
                </ul>
                <div class="">

                </div>
                <div class="text-center mt-auto">

                </div>
                <div class="container buttons-container">
                  <div class="row mb-3 justify-content-center mt-auto">
                    <div class="col-auto">
                      <a class="btn" type="button" target="_blank"
                      href="http://zapisy.genomed.pl/calendar/?name=genom-profilaktyczny-konsultacja-genetyczna">
                        {{$t('sets.book_a_consultation')}}
                      </a>
                    </div>
                  </div>
                  <div class="row justify-content-center">
                    <div class="col-auto">
                      <a class="btn advanced-button" type="button" data-toggle="collapse" data-target="#collapseThree"
                        aria-expanded="false" aria-controls="collapseThree">
                        {{$t('sets.read_more')}}
                      </a>
                    </div>
                    <div class="col-auto">
                      <a class="btn" type="button" target="_blank"
                      :href="$t('sets.premium_link')">
                        {{$t('order')}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row">
          <div class="col-12">
            <div class="accordion accordion-primary" id="accordionSetsDescription">
              <div class="card">
                <div id="collapseOne" class="collapse" aria-labelledby="headingOne"
                  data-parent="#accordionSetsDescription">
                  <div class="card-body p-3">
                    <h5>{{$t('sets.basic')}}</h5>
                    <div class="for-who">{{$t('sets.basic_for_who')}}</div>
                    <p v-html="$t('sets.basic_description')"></p>
                  </div>
                </div>
              </div>
              <div class="card">
                <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo"
                  data-parent="#accordionSetsDescription">
                  <div class="card-body p-3">
                    <h5>{{$t('sets.advanced')}}</h5>
                    <div class="for-who">{{$t('sets.advanced_for_who')}}</div>
                    <p v-html="$t('sets.advanced_description')"></p>
                  </div>
                </div>
              </div>
              <div class="card">
                <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                  data-parent="#accordionSetsDescription">
                  <div class="card-body p-3">
                    <h5>{{$t('sets.premium')}}</h5>
                    <div class="for-who">{{$t('sets.premium_for_who')}}</div>
                    <p v-html="$t('sets.premium_description')"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="clear"></div>
        <div class="row">
          <div class="col-lg-6 offset-lg-3">
            <div class="text-center mt-auto">
              <router-link :to="{name:'compare-packages-view'}" class="btn btn-block order-set-btn"
                id="porownaj_zestaw">{{$t('compare_packages.compare_packages')}}
              </router-link>
              <router-link :to="{name:'collection-set-order-view'}" class="btn btn-block order-set-btn d-none">
                {{$t('collection_set_order.order_set_only')}}
              </router-link>
            </div>
          </div>
        </div>
        <div class="egg">
          <img src="../assets/img/egg-box.png" alt="" class="egg-img">
          <img src="../assets/img/egg.png" alt="" class="egg-imgmobile">
          <div id="egg_text" class="row">
            <div class="col-12 col-md-9 col-xl-7">
              <h1 class="title">{{$t('analysis_order.special_casing')}}</h1>
              <p class="text">{{$t('analysis_order.special_casing_info')}}</p>
            </div>
            <div id="egg_mobile_1" class="col text-right pr-0 pr-lg-3 pr-xl-5 ml-0 mr-xl-4">
              <div class="text-center">
                <a href="#" class="btn btn-lg btn-default button disabled d-none" aria-disabled="true">
                  {{$t('analysis_order.see_offer')}}
                </a>
              </div>
            </div>
          </div>
          <div id="egg_mobile_2" class="text-center">
            <div class="text-center">
              <a type="button" class="btn btn-lg btn-default button disabled d-none">{{$t('analysis_order.see_offer')}}</a>
            </div>
          </div>
        </div>
      </div>
    </div>


    <!-- Why it’s worth it? -->
    <div class="container four-element">
      <div class="row text-center">
        <div class="col-12">
          <h2 class="title">{{$t('home.why_genomed')}}</h2>
        </div>
      </div>

      <div class="items pt-5">
        <div class="row row-1">
          
          <div class="col-lg-6 item pb-5">
            <router-link :to="{ name: 'about-us-view', hash: '#confidence' }">
            <div class="row">
              <div class="col-auto">
                <img src="../assets/img/lock-icon.png" alt="" class="img img-1">
              </div>
              
              <div class="col item-card">
                <h5 class="card-title">{{$t('home.security')}} &amp; {{$t('home.confidence')}}</h5>
                <p class="card-text">{{$t('home.security_confidence_info')}}</p>
              </div>
            
            </div>
            </router-link>
          </div>
        

          <div class="col-lg-6 item pb-5">
            <router-link :to="{ name: 'about-us-view', hash: '#professionalism' }">
            <div class="row">
              <div class="col-auto">
                <img src="../assets/img/prof_icon.png" alt="" class="img img-2">
              </div>
              <div class="col item-card">
                <h5 class="card-title">{{$t('home.professionalism')}}</h5>
                <p class="card-text">{{$t('home.professionalism_info')}}</p>
              </div>
            </div>
            </router-link>
          </div>
        </div>

        <div class="row row-2">
          <div class="col-lg-6 item pb-5">
            <router-link :to="{ name: 'about-us-view', hash: '#polish_reference_database' }">
            <div class="row">
              <div class="col-auto">
                <img src="../assets/img/polgenom_icon.png" alt="" class="img img-1">
              </div>
              <div class="col item-card">
                <h5 class="card-title">{{$t('home.polish_reference_database')}}</h5>
                <p class="card-text">{{$t('home.polish_reference_database_info')}}</p>
              </div>
            </div>
          </router-link>
          </div>

          <div class="col-lg-6 item pb-5">
            <router-link :to="{ name: 'about-us-view', hash: '#our_tools' }">
            <div class="row">
              <div class="col-auto">
                <img src="../assets/img/brovar_icon.png" alt="" class="img img-2">
              </div>
              <div class="col item-card">
                
                <h5 class="card-title">{{$t('home.our_tools')}}</h5>
                <p class="card-text">{{$t('home.our_tools_info')}}</p>
              </div>
            </div>
          </router-link>
          </div>
        </div>

        <div class="row row-3">
          <div class="col-lg-6 item pb-5">
            <router-link :to="{ name: 'about-us-view', hash: '#medical_knowledge' }">
            <div class="row">
              <div class="col-auto">
                <img src="../assets/img/med-icon.png" alt="" class="img img-3">
              </div>
              <div class="col item-card">
                <h5 class="card-title">{{$t('home.medical_knowledge')}}</h5>
                <p class="card-text">{{$t('home.medical_knowledge_info')}}</p>
              </div>
            </div>
          </router-link>
          </div>

          <div class="col-lg-6 item">
            <router-link :to="{ name: 'about-us-view', hash: '#confidence' }">
            <div class="row">
              <div class="col-auto">
                <img src="../assets/img/storage-icon.png" alt="" class="img img-4">
              </div>
              <div class="col item-card">
                <h5 class="card-title">{{$t('home.data_storage')}}</h5>
                <p class="card-text">{{$t('home.data_storage_info')}}</p>
              </div>
            </div>
          </router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="main-page-section row text-justify">
      <div class="col-12 text-center pb-5">
        <h2 class="title">{{ $t('about_us.paragraph_7_title') }}</h2>
        <div class="about_us_content" v-html="$t('about_us.paragraph_7_content')"></div>
        <div class="row certifiates-grid pb-4">
          <div class="col-6 col-md-3 certificate-col text-center border-right">
            <a href="https://diagnostyka.genomed.pl/media/uploads/stories/certyfikaty/2022-emqn-performance-certificates.pdf"
              target="_blank">
              <div class="row h-100">
                <div class="col-12 align-self-center">
                  <img src="../assets/img/cert_1.jpg" class="img-fluid" alt="..."><br>
                </div>
                <div class="col-12 align-self-end pt-3">
                  2022
                </div>
              </div>
            </a>
          </div>
          <div class="col-6 col-md-3 certificate-col text-center border-right">
            <a href="http://genomed.pl/images/stories/certyfikaty/certyfikat_ptgc_2020.pdf"
              target="_blank">
              <div class="row h-100">
                <div class="col-12 align-self-center">
                  <img src="../assets/img/cert_2.jpg" class="img-fluid" alt="..."><br>
                </div>
                <div class="col-12 align-self-end pt-3">
                  2021
                </div>
              </div>
            </a>
          </div>
          <div class="col-6 col-md-3 certificate-col text-center border-right">
            <a href="https://diagnostyka.genomed.pl/media/uploads/stories/certyfikaty/2023-cystic_fibrosis-9530_certificate_cfeqa2023.pdf"
            target="_blank">
              <div class="row h-100">
                <div class="col-12 align-self-center">
                  <img src="../assets/img/cert_3.png" class="img-fluid" alt="..."><br>
                </div>
                <div class="col-12 align-self-end pt-3">
                  2023
                </div>
              </div>
            </a>
          </div>
          <div class="col-6 col-md-3 certificate-col text-center">
            <a href="http://www.genomed.pl/images/stories/certyfikaty/cert_2854.pdf"
            target="_blank">
              <div class="row h-100">
                <div class="col-12 align-self-center">
                  <img src="../assets/img/cert_4.jpg" class="img-fluid" alt="..."><br>
                </div>
                <div class="col-12 align-self-end pt-3">
                  2012
                </div>
              </div>
            </a>
          </div>
          </div>
      </div>
    </div>
  </div>

</template>

<script>

  import router from '../routes';
  import VueCompareImage from 'vue-compare-image';

  export default {
    name: "Home",
    computed: {
      count() {
        return this.$store.state.dummy.county;
      }
    },
    methods: {
      goto: function (route) {
        router.push({name: route})
      },
      smoothscroll(id) {
        var element = document.getElementById(id);
        const y = element.getBoundingClientRect().top + window.pageYOffset + 0;
        window.scrollTo({top: y, behavior: 'smooth', block: 'start'});
      }
    },
    components: { VueCompareImage },
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Home.vue